<script setup lang="ts">
import SaveButton from "@/components/SaveButton.vue";
import LoggedOut from "@/layouts/LoggedOut.vue";
import { ref } from "vue";
import { useConfirmContactPhoneNumber } from "./contactPhoneNumberConfirmationCrud";

const props = defineProps<{
  token: string;
}>();

const showSuccessMessage = ref(false);

const { confirmContactPhoneNumber, confirmContactPhoneNumberStatus } =
  useConfirmContactPhoneNumber(props.token, {
    onSuccess: () => {
      showSuccessMessage.value = true;
    },
  });
</script>

<template>
  <LoggedOut>
    <h1>Bestätige deine Telefonnummer</h1>
    <form
      v-if="!showSuccessMessage"
      class="column"
      @submit.prevent="confirmContactPhoneNumber()"
    >
      <p>
        Bitte bestätige deine Telefonnummer, damit wir dich erreichen können.
      </p>

      <SaveButton :saving-status="confirmContactPhoneNumberStatus"
        >Telefonnummer bestätigen</SaveButton
      >
    </form>
    <p v-else>
      Vielen Dank! Deine Telefonnummer wurde bestätigt. Wir werden dich
      kontaktieren, sobald es Neuigkeiten gibt.
    </p>
  </LoggedOut>
</template>

<style scoped>
button[type="submit"] {
  width: 100%;
  justify-content: center;
}
</style>
